export function getMustNotBeEmpty(input, alertElement) {
	if (input === '') {
		document.getElementById(alertElement).innerHTML = '<span>Pole nie może być puste</span>';
		return false;
	} else {
		document.getElementById(alertElement).innerHTML = '';
		return true;
	}
}

export function getMustBeLongEnough(input, alertElement, message, limit) {
	if (input !== '' && input.length > limit) {
		document.getElementById(alertElement).innerHTML = message;
		return false;
	} else {
		return true;
	}
}

export function getMustBeChecked(input, alertElement, message) {
	if (input === '' || !input || input.length === 0) {
		document.getElementById(alertElement).innerHTML = message;
		return false;
	} else {
		document.getElementById(alertElement).innerHTML = '';
		return true;
	}
}

export function getMustNumeric(input, alertElement, message) {
	if (input && input !== '' && isNaN(input.replace(',', '.').replace(/\s+/g, '').replace('%', ''))) {
		document.getElementById(alertElement).innerHTML = message;
		return false;
	} else {
		return true;
	}
}

export function getMustBeGreaterThanZero(input, alertElement, message) {
	if (input !== '' && !isNaN(input) && input.length <= 0) {
		document.getElementById(alertElement).innerHTML = message;
		return false;
	} else {
		return true;
	}
}

export function getBlocksMustBeChosen(input, alertElement, message) {
	if (!input || input.length === 0) {
		document.getElementById(alertElement).innerHTML = message;
		return false;
	} else {
		document.getElementById(alertElement).innerHTML = '';
		return true;
	}
}

export function startsWith(input, beginning, alertElement, message) {
	if (input.length > 0) {
		if (input.substring(0, beginning?.length) !== beginning) {
			document.getElementById(alertElement).innerHTML = message;
			return false;
		} else {
			document.getElementById(alertElement).innerHTML = '';
			return true;
		}
	}
}

export function listContainsValue(input, list, propertiesName, alertElement, message) {
	if (input.length > 0) {
		if (list.some(item => item[propertiesName] === input)) {
			document.getElementById(alertElement).innerHTML = message;
			return false;
		} else {
			return true;
		}
	}
}

export function listContainsValueClean(input, list, propertiesName) {
	if (list.some(item => item[propertiesName] === input)) {
		return false;
	} else {
		return true;
	}
}

export function validateNip(nip) {
	if (nip.length > 0) {
		let nipWithoutDashes = nip.replace(/-/g, '');
		let reg = /^[0-9]{10}$/;
		if (reg.test(nipWithoutDashes) === false) {
			return false;
		} else {
			let digits = ('' + nipWithoutDashes).split('');
			let checksum = (6 * parseInt(digits[0]) + 5 * parseInt(digits[1]) + 7 * parseInt(digits[2]) + 2 * parseInt(digits[3]) + 3 * parseInt(digits[4]) + 4 * parseInt(digits[5]) + 5 * parseInt(digits[6]) + 6 * parseInt(digits[7]) + 7 * parseInt(digits[8])) % 11;
			let validation = parseInt(digits[9]) === checksum;
			if (!validation) {
				return false;
			} else {
				return true;
			}
		}
	}
}

export function validatePesel(pesel) {
	if (pesel.length > 0) {
		let reg = /^[0-9]{11}$/;
		if (reg.test(pesel) === false) {
			return false;
		} else {
			let digits = ('' + pesel).split('');
			let checksum = (9 * parseInt(digits[0]) + 7 * parseInt(digits[1]) + 3 * parseInt(digits[2]) + 1 * parseInt(digits[3]) + 9 * parseInt(digits[4]) + 7 * parseInt(digits[5]) + 3 * parseInt(digits[6]) + 1 * parseInt(digits[7]) + 9 * parseInt(digits[8]) + 7 * parseInt(digits[9])) % 10;
			let validation = parseInt(digits[10]) === checksum;
			if (!validation) {
				return false;
			} else {
				return true;
			}
		}
	}
}

/* correction validations */

export function getRateMustByBetweenZeroAndHundred(input, alertElement, message) {
	if (input !== '' && !isNaN(input) && (input < 0.01 || input > 100)) {
		document.getElementById(alertElement).innerHTML = message;
		return false;
	} else {
		return true;
	}
}

export function getMustBeGreaterThan(inputBigger, inputSmaller, alertElement, message) {
	if (inputBigger !== '' && inputSmaller !== '' && !isNaN(inputBigger * inputSmaller) && (inputBigger < inputSmaller)) {
		document.getElementById(alertElement).innerHTML = message;
		return false;
	} else {
		return true;
	}
}

export function validateProjectNumber(projectNumber, alertElement, message) {
	if (projectNumber.length > 0) {
		let reg = /^[A-Z]{4}\.\d{2}\.\d{2}-[A-Z]{2}\.\w{2}-\w{4}\/\d{2}$/;
		if (reg.test(projectNumber) === false) {
			document.getElementById(alertElement).innerHTML = message;
			return false;
		} else {
			document.getElementById(alertElement).innerHTML = '';
			return true;
		}
	}
	return true;
}

export function startsWithProjectNumber(projectNumber, alertElement, message) {
	if (projectNumber.length > 0) {
		const projectNumberRegex = /^[A-Z]{4}\.\d{2}\.\d{2}-[A-Z]{2}\.\w{2}-\w{4}\/\d{2}/;
        if (!projectNumberRegex.test(projectNumber)) {
            document.getElementById(alertElement).innerHTML = message;
            return false;
        } else {
            document.getElementById(alertElement).innerHTML = '';
            return true;
        }
    }

    return true;
}

